import { apiClient, getToken, getAuthId } from '@devd-client/api';
import type { UserResponse } from './user.types';

export const getUser = (): Promise<UserResponse> =>
  apiClient(`/v2/account/user/${getAuthId()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
